module.exports = __webpack_public_path__ + "img/table-tennis.622eb5d2.svg";